import {NgClass, NgOptimizedImage, SlicePipe} from '@angular/common';
import {Component, computed, effect, inject, Injector, input, OnInit, runInInjectionContext} from '@angular/core';
import {Router} from '@angular/router';
import {
	IonCard,
	IonCardContent,
	IonCardHeader,
	IonCardTitle,
	IonCol,
	IonContent,
	IonGrid,
	IonIcon,
	IonImg,
	IonRow,
	IonText,
	PopoverController
} from '@ionic/angular/standalone';
import {TranslocoDirective} from '@jsverse/transloco';
import {addIcons} from 'ionicons';
import {banOutline, closeOutline, ellipse, starOutline} from 'ionicons/icons';
import {Profile} from '@models';
import {Gender2LabelMapping, Pronouns2LabelMapping, Role2LabelMapping} from '@enums';
import {PrivateMessageService, ProfileService, TranslateHelperService} from '@services';

@Component({
	           selector: 'app-profile-popin',
	           standalone: true,
	           templateUrl: './profile-popin.component.html',
	           imports: [
			TranslocoDirective,
		           IonContent,
		           IonCard,
		           IonCardHeader,
		           IonCardTitle,
		           IonIcon,
		           IonCardContent,
		           IonGrid,
		           IonRow,
		           IonCol,
		           IonImg,
		           NgClass,
		           SlicePipe,
		           NgOptimizedImage,
		           IonText
	           ],
	           styleUrls: ['./profile-popin.component.scss']
           })
export class ProfilePopinComponent implements OnInit {
	public roles2LabelMapping = Role2LabelMapping;
	public gender2LabelMapping = Gender2LabelMapping;
	public pronouns2LabelMapping = Pronouns2LabelMapping;

	profile = input.required<Profile>();
	selected_status = input.required<string>();
	currentProfile = input.required<Profile>();

	statusClass = computed(() => {
		switch (this.selected_status()) {
			case 'online':
				return 'is-online';
			case 'offline':
				return 'is-offline';
			default:
				return 'is-away';
		}
	});

	isBlocked = false;
	protected profileService = inject(ProfileService);
	protected translateService: TranslateHelperService = inject(TranslateHelperService);
	private readonly router: Router = inject(Router);
	private readonly pmService: PrivateMessageService = inject(PrivateMessageService);
	private readonly popoverController: PopoverController = inject(PopoverController);
	private injector = inject(Injector);

	constructor() {
		addIcons({banOutline, closeOutline, ellipse, starOutline});
	}

	ngOnInit() {
		runInInjectionContext(this.injector, () => effect(() => {
			this.profile().isBlocked = this.currentProfile().blocked.find(uid => uid === this.profile().uuid) !== undefined;
			this.profile().isFavorite = this.currentProfile().favorits.find(uid => uid === this.profile().uuid) !== undefined;
		}));
	}

	closePopover() {
		return this.popoverController.dismiss();
	}

	blockUser() {
		this.profileService.blockUser(this.profile().uuid);
		this.profileService.removeUserFavorit(this.profile().uuid).then();
		this.profile().isBlocked = true;
		this.profile().isFavorite = false;
	}

	addUserFavorit() {
		this.profileService.addUserFavorit(this.profile().uuid);
		this.profile().isFavorite = true;
	}

	sendPrivateMessage(selectedProfile: Profile) {
		this.pmService.sendPrivateMessage(this.currentProfile(), selectedProfile);
		return this.closePopover();
	}

	unblockUser() {
		this.profileService.unblockUser(this.profile().uuid);
		this.profile().isBlocked = false;
	}

	removeUserFavorit() {
		this.profileService.removeUserFavorit(this.profile().uuid).then(() => this.profile().isFavorite = false);
	}

	openBigProfile(profile: Profile) {
		this.router.navigateByUrl(this.translateService.localize(`/app/visitor/${profile?.username}`)).then(() => this.closePopover());
	}
}
